import { HttpClient } from './serviceBase';

const req = {
    method: 'GET',
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    },
}

class CountryApiService {
    GetCountries = async () =>
        await HttpClient.Get('/api/geo/countries');
    

    GetState = async ( countryId ) => 
        await HttpClient.Get(`/api/geo/countries/${countryId}/states`);

    GetCities = ( stateCode = 'AR-B' ) =>
        fetch(`https://api.mercadolibre.com/states/${stateCode}`, req)
            .then(res => {
                if (!res.ok)
                    throw new Error(res.text());

                return res.json();
            })
            .then(res => res.cities);
    
    GetCurrenciesByCountry = async (countryId) =>
        await HttpClient.Get(`/api/geo/countries/${countryId}/currencies`);

    GetCurrencies = async () =>
        await HttpClient.Get(`/api/geo/currencies`);
}

export default new CountryApiService();